import Container from "../../components/styled/Container.styled"
import { Heading } from "../../components/styled/Heading"
import ClaimsCard from "../../components/Dashboard/ClaimsCard"
import ParticipantsCard from "../../components/Dashboard/ParticipantsCard"
import TopSKUsCard from "../../components/Dashboard/TopSKUsCard"
import DealersCard from "../../components/Dashboard/DealersCard"
import { GET_DASHBOARD_STAT } from "../../graphql/queries"
import dayjs from "dayjs"
import { dateFormatForBackend } from "../../constants/general"
import { useState } from "react"
import { useQuery } from "@apollo/client"
import { Spin } from "antd"

const Dashboard = () => {
  const [firstDay] = useState<string>(() =>
    dayjs().startOf("month").format(dateFormatForBackend)
  )
  const [lastDay] = useState<string>(() =>
    dayjs().endOf("month").format(dateFormatForBackend)
  )

  const { data, loading } = useQuery(GET_DASHBOARD_STAT, {
    variables: {
      startDate: firstDay,
      endDate: lastDay,
    },
  })

  return (
    <Container>
      <Heading
        heading="Kenda Advanced Sales Rewards"
        description="Administrator Module"
      />
      {!loading ? (
        <>
          <div className="row">
            <div className="col-lg-5 col-md-12 px-0 pt-4">
              <ClaimsCard
                claims={
                  data?.getAllDashboardStats?.claimStatsData ?? {
                    pendingClaimsCount: 0,
                    totalClaimsCount: 0,
                    approvedClaimsCount: 0,
                    declinedClaimsCount: 0,
                  }
                }
              />
            </div>
            <div className="col-lg-7 col-md-12 px-0 pt-4">
              <ParticipantsCard
                participantsByRegion={
                  data?.getAllDashboardStats?.totalParticipantsStats ?? {
                    participantStatsByRegion: [],
                    totalEnrolledParticipantsCount: 0,
                  }
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-8 col-md-12 px-0 pt-4">
              <TopSKUsCard
                TopSKUs={
                  data?.getAllDashboardStats?.salesClaimMadeOnProductData ?? []
                }
              />
            </div>
            <div className="col-xl-4 col-md-12 px-0 pt-4">
              <DealersCard
                TopSKUDealers={
                  data?.getAllDashboardStats?.salesClaimMadeDealerWiseData ?? []
                }
              />
            </div>
          </div>
        </>
      ) : (
        <Spin
          size="large"
          style={{
            display: "flex",
            justifyContent: "center",
            height: "40vh",
            alignItems: "center",
          }}
        />
      )}
    </Container>
  )
}

export default Dashboard
